import { render, staticRenderFns } from "./welfarebenefits.vue?vue&type=template&id=e7d6f916&scoped=true&"
import script from "./welfarebenefits.vue?vue&type=script&lang=js&"
export * from "./welfarebenefits.vue?vue&type=script&lang=js&"
import style0 from "./welfarebenefits.vue?vue&type=style&index=0&id=e7d6f916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d6f916",
  null
  
)

export default component.exports